<template>
	<div v-if="componentRow.length > 0">

		<div class="row comp_row">
			<div class="comp_col" :class="(componentRow.length === 1) ? 'col-12' : 'col-6'" v-for="componentName in componentRow">
				<component-logic :program-guide="programGuide" :careerGoal="careerGoal" :component-name="componentName"></component-logic>
			</div>
		</div>

	</div>
</template>

<script>
	import ComponentLogic from './ComponentLogic'

	export default {
	  name: 'component-row',
	  props: ['componentRow','programGuide', 'careerGoal'],
	  components: {
	  	ComponentLogic
	  }
	}
</script>



// WEBPACK FOOTER //
// src/app/dashboard/components/ComponentRow.vue